import Vue from "vue"

export const prefetchSrcriptLink = 'https://scripts.sirv.com'
export let prefetchAccountLink = Vue.observable({ value: `https://demo.sirv.com` })
export const showPrefetch = Vue.observable({ value: false })

const prefetchLinks = () => ([
    `<link rel="preconnect" href="${prefetchSrcriptLink}" crossorigin>`,
    `<link rel="preconnect" href="${prefetchAccountLink.value}" crossorigin>`,
    `<link rel="dns-prefetch" href="${prefetchSrcriptLink}">`,
    `<link rel="dns-prefetch" href="${prefetchAccountLink.value}">`
])

const prefetchCodeInline = () => (`<span class="tag">&lt;head&gt;</span>
  <span class="tag">&lt;link</span> <span class="atn">rel</span><span class="pun">=</span><span class="atv">"preconnect"</span> <span class="atn">href</span><span class="pun">=</span><span class="atv">"${prefetchSrcriptLink}"</span> <span class="atn">crossorigin</span><span class="tag">&gt;</span>
  <span class="tag">&lt;link</span> <span class="atn">rel</span><span class="pun">=</span><span class="atv">"preconnect"</span> <span class="atn">href</span><span class="pun">=</span><span class="atv">"${prefetchAccountLink.value}"</span> <span class="atn">crossorigin</span><span class="tag">&gt;</span>
  <span class="tag">&lt;link</span> <span class="atn">rel</span><span class="pun">=</span><span class="atv">"dns-prefetch"</span> <span class="atn">href</span><span class="pun">=</span><span class="atv">"${prefetchSrcriptLink}"</span><span class="tag">&gt;</span>
  <span class="tag">&lt;link</span> <span class="atn">rel</span><span class="pun">=</span><span class="atv">"dns-prefetch"</span> <span class="atn">href</span><span class="pun">=</span><span class="atv">"${prefetchAccountLink.value}"</span><span class="tag">&gt;</span>
<span class="tag">&lt;/head&gt;</span>
\n`)

const prefetchCodeHTML = () => (`<head>
  ${ prefetchLinks().join(`\n  `) }
</head>
\n`)


export function prefetchCodeInlineComputed(){
    return showPrefetch.value ? prefetchCodeInline() : ''
}

export function prefetchCodeHTMLComputed (){
    return showPrefetch.value ? prefetchCodeHTML() : ''
}

export const loadPrefetchToPage = () => {
    const head = document.querySelector('head')
    const prefentchInstalled = document.querySelectorAll('.prefetch-links')

    if( prefentchInstalled.length ){
        prefentchInstalled.forEach( 
            it => {
                head.removeChild(it)
            } 
        )
    }

    if( ! showPrefetch.value ) return

    prefetchLinks().forEach(
        ( it, idx ) => {
            const crossorigin = it.includes('crossorigin'),
                link = document.createElement('link')

            link.classList = 'prefetch-links'
            link.rel = it.includes('preconnect') ? 'preconnect' : 'dns-prefetch'
            
            if( crossorigin )
                link.setAttribute('crossorigin', '')

            if( (idx + 1) % 2 === 0 ) link.href = prefetchAccountLink.value
            else link.href = prefetchSrcriptLink

            head.appendChild( link )
        }
    )
}